import React, { ReactElement } from 'react';
import { CaretRightOutlined } from '@ant-design/icons';

const CollapseExpandIconComponent = ({ isActive }: { isActive?: boolean }): ReactElement =>
  <CaretRightOutlined rotate={isActive ? 90 : 0} />;

export default CollapseExpandIconComponent;
